import {
  call,
  put,
  takeLatest,
  select,
} from 'redux-saga/effects';

import {
  GET_COURSE_LIST,
  GET_COURSE_LIST_SUCCESS,
} from '@/action-types/course';

import {
  GET_COURSE_CATEGORIES_SUCCESS,
} from '@/action-types/course-category';

import api from '@/api/course';

export function* getCourseListSaga() {
  const { course } = yield select();

  try {
    // update only after 10 mins
    if (
      course.lastUpdated === undefined
      || ((new Date()).getTime() - course.lastUpdated > 10 * 60 * 1000)
    ) {
      const response = yield call(api.getCoursesList);

      yield put({ type: GET_COURSE_LIST_SUCCESS, data: response.data.getCoursesList || [] });
      yield put({
        type: GET_COURSE_CATEGORIES_SUCCESS, data: response.data.getCourseCategories || [],
      });
    } else {
      // no need update
    }
  } catch (e) {
    //
  }
}

export default function* loading() {
  yield takeLatest(GET_COURSE_LIST, getCourseListSaga);
}
